import React, { useState, useRef } from 'react';
import { getEncUrlDhofar } from '../../actions/CCAvenueAction'
import swal from 'sweetalert';
import { useNavigate } from 'react-router-dom';
import { nGeniusPaymentGateway, salesforceSendFormNumber } from '../../actions/StudentAction';


const NGenius = ({paymentConfig,userDetail,selectedMethodFeeDetail,feeDetail}) => {
    const formRef = useRef(null);
    const navigate = useNavigate()
    const [loading,setLoading] = useState(false)
    const [encRequestRes, setEncRequestRes] = useState()
    const [formActionUrl,setFormActionUrl] = useState();

    const {form_num,id} = userDetail !==undefined && userDetail
    const {instData} = selectedMethodFeeDetail
    const {installment_type,net_payable_amount,scholarship_amount,scholarship_percentage,total_fee} = feeDetail !==undefined && feeDetail
    let accessCode = `${paymentConfig.access_code}`

    // let order_no =new Date().getUTCMilliseconds();
    // let orderWithFormNum=`${id}${order_no}${form_num}`

    const checkout = async () => {
        setLoading(true)
        const successUrl = `${process.env.REACT_APP_PUBLIC_URL}/student/paymentstatus/success`;
        const failureUrl = `${process.env.REACT_APP_PUBLIC_URL}/student/paymentstatus/failure`;
        const data = {
            // student_id: id,
            amount:parseFloat(instData?.amount).toFixed(2) ,
            gateway_id: paymentConfig.id,
            // order_id:orderWithFormNum,
            success_url:successUrl,
            failure_url:failureUrl,
            scholarship_amount:scholarship_amount,
            net_payable_amount:net_payable_amount,
            installments_id:instData?.installment_id,
            installment_type:instData?.installment_number ==0 ? "lumpsum" :installment_type,
            scholarship_percentage:scholarship_percentage,
            actual_inst_amt:parseFloat(instData?.amount).toFixed(2),
            course_fee:total_fee,
            installments_number:instData?.installment_number
          }
      

        try {
          const res = await nGeniusPaymentGateway(data)
          if (res.status) {
              setLoading(true)
              salesforceSendFormNumber({form_num:form_num,status:'payment_initiated'})
              window.location.href=res?.payment_url
          }

          else {
              swal(`Payment Failed! We couldn't process your payment. Please Try Again!`, '', 'error');
              setLoading(false)
          }
          
        } catch (error) {
            swal('Something went wrong','','error')
            console.log('n-genius error...',error)
            setLoading(false)
        }
        
            
    }
   
    return (
        <React.Fragment>
            <div>
            {loading ? <button type="submit" disabled className="banktransfer_btn">
                    <span className="spinner-border spinner-border-sm me-3" role="status" aria-hidden="true"></span>
                    Processing ...</button> : 
               <button onClick={checkout} className='banktransfer_btn'>N-Genius</button>
            }
                
                {/* <form ref={formRef}
                    method="POST"
                    name="redirect"
                    action={formActionUrl !==undefined ? formActionUrl : ''}
                    >
                    <input type="hidden" id="encRequest" name="enc_request" value={encRequestRes} />
                    <input type="hidden" name="access_code" id="access_code" value={accessCode} />
                </form> */}
            </div>

        </React.Fragment>
    )
}

export default NGenius